/**
 * Set the visual state of a play icon element.
 *
 * @param {jQuery|Element} icon   - The .g-chatform-message-play element (jQuery or DOM).
 * @param {boolean|'loading'} playing
 *   - false       → idle   (no class)        show: play icon
 *   - 'loading'   → spinner (is-loading)     show: spinner
 *   - true        → active  (is-playing)     show: pause icon
 */
export function setPlayIconState(icon, playing) {
    if (!icon) return;

    if (typeof icon.toggleClass === 'function') {
        // jQuery element
        if (playing === 'loading') {
            icon.removeClass('is-playing').addClass('is-loading');
        } else if (playing) {
            icon.removeClass('is-loading').addClass('is-playing');
        } else {
            icon.removeClass('is-playing is-loading');
        }
    } else if (icon.classList) {
        // Native DOM element
        if (playing === 'loading') {
            icon.classList.remove('is-playing');
            icon.classList.add('is-loading');
        } else if (playing) {
            icon.classList.remove('is-loading');
            icon.classList.add('is-playing');
        } else {
            icon.classList.remove('is-playing', 'is-loading');
        }
    }
}
